import * as React from "react";
import { Link } from "react-router-dom";
import { PageHelpers } from "../helpers/PageHelpers";

export interface IBackLinkProps {
  backToPageLinkUrl : string;
  backToPageLinkText : string;
  isExternalUrl? : boolean;
  additionalClassName? : string;
}

export const BackLink = (props : IBackLinkProps) => {
  if (props.backToPageLinkUrl.indexOf("http") == 0 || !!props.isExternalUrl) {
    
    let url = props.backToPageLinkUrl || "";
    if (url.indexOf("~") == 0) {
      url = url.slice(1);
    }

    return <a
      className={"link__single link__back-to-mijnfnv " + props.additionalClassName}
      href={url}
    > 
      <span className="icon icon-open-chevron-left link__single-icon--left"></span>
      <span>{props.backToPageLinkText}</span>
    </a>;
  }
  return <Link
      className={"link__single link__back-to-mijnfnv " + props.additionalClassName}
      to={PageHelpers.getMijnFNVRootPathForRole(
        props.backToPageLinkUrl
      )}
    >
      <span className="icon icon-open-chevron-left link__single-icon--left"></span>
      <span>{props.backToPageLinkText}</span>
    </Link>;
};